export default {}
export const API_URL = process.env.VUE_APP_ROOT_API
export const ASSETS_URL = process.env.VUE_APP_ASSETS_URL
export const REDIRECT_URL = process.env.VUE_APP_REDIRECT_URL

export const AZURE_B2C_TENANT=process.env.VUE_APP_AZURE_B2C_TENANT
export const AZURE_B2C_SIGN_IN_POLICY=process.env.VUE_APP_AZURE_B2C_SIGN_IN_POLICY
export const AZURE_B2C_CLIENT_ID=process.env.VUE_APP_AZURE_B2C_CLIENT_ID
export const AZURE_B2C_SCOPES=process.env.VUE_APP_AZURE_B2C_SCOPES
export const AZURE_B2C_INSTANCE=process.env.VUE_APP_AZURE_B2C_INSTANCE